import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import Box from "../../../../../../../../ui/Box";
import SquareButton from "../../../../../../../../ui/SquareButton";
import Button from "../../../../../../../../ui/Button";
import ActionsMenu from "../../../../../../../../ui/ActionsMenu";
import UndoIcon from "@material-ui/icons/Undo";
import ToolTip from "@material-ui/core/Tooltip";

const useStyles = makeStyles(() => ({
  topBar: {
    display: "flex",
    justifyContent: "space-between"
  },
  topBarLeft: {
    display: "flex",
    "& > button": {
      marginRight: 12
    }
  },
  topBarRight: {
    display: "flex",
    "& > div": {
      marginLeft: 12
    }
  }
}));

const TopBar = ({
  reload,
  returnBack,
  isUpdating,
  update,
  onDelete,
  isDeleting,
  disabled,
  editmode,
  setEditMode,
  setViewMode,
  sendToCatalog
}) => {
  const classes = useStyles();

  const menuItems = [
    {
      label: "Удалить программу",
      onClick: onDelete,
      disabled: isDeleting
    }
  ];

  return (
    <Box>
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <SquareButton onClick={returnBack}>
            <ChevronLeftIcon fontSize="small" />
          </SquareButton>
          <SquareButton onClick={reload}>
            <CachedIcon fontSize="small" />
          </SquareButton>
        </div>

        <div className={classes.topBarRight}>
          {editmode ? (
            <>
              <SquareButton style={{marginRight: 16}}
                onClick={setViewMode}
                title="Вернуться в режим просмотра">
                <UndoIcon fontSize="small" />
              </SquareButton>
              <Button
                onClick={update}
                disabled={disabled || isUpdating || isDeleting}
                loading={isUpdating}
                color="green">
                Сохранить
              </Button>
            </>
          ) :
            <Button onClick={setEditMode} color="gray">
            Редактировать
            </Button>}
          <Button onClick={sendToCatalog} color="gray" style={{marginLeft: 10}}>
            Отправить в каталог
          </Button>
          <ActionsMenu actions={menuItems} />
       </div>

      </div>
    </Box>
  );
};

export default withRouter(TopBar);
